import { firebaseApp, firebaseDb, uid } from './index'
import * as S from '../config/accountSubscription'

export const setAccount = (account, dispatch, onSuccess) => {
  let updates = {}
  updates[`users/${uid()}/account/as`] = account.as
  updates[`users/${uid()}/account/o`] = account.o
  firebaseDb().ref().update(updates)
    .then(() => {
      if ( onSuccess) {
        dispatch(onSuccess(account))
      }
    })
    .catch((error) => {
      console.log(error); 
    })
}

export const getOrderNo = (onSuccess) => {
  firebaseDb().ref('/ORDERS/orderNo').transaction(orderNo => {
    if (orderNo) {
      orderNo = orderNo + 1
    }
    return orderNo
  })
  .then(tr => {
    if (tr.snapshot.exists()) {
      onSuccess(tr.snapshot.val())
    }
  })
}

export const saveOrder = (regData, accounState, onSuccess, onError) => {
  let user = firebaseApp.auth().currentUser
  const userid = user.uid  
  const { acceptCondition, ...regDataOrder } = regData
  regDataOrder.type = S.getSubLabel(regData.subscription)
  regDataOrder.amount = `${S.getSubTotal(regData.subscription)} Kč`
  regDataOrder.user = user.email
  regDataOrder.uid = userid
  let updates = {}
  updates[`ORDERS/inbox/${getId()}`] = regDataOrder
  updates[`users/${userid}/account/as`] = accounState
  updates[`users/${userid}/regData`] = regData
  const { orderNo, date, type } = regDataOrder
  updates[`users/${userid}/history/${orderNo}`] = `${date}, ${type}`
  firebaseDb().ref().update(updates)
    .then(() => {
      if (onSuccess) {
        onSuccess()
      }
    })
    .catch((error) => {
      if (onError) {
        onError(error)
      }
    })
}

const getId = () => {
  let d = new Date()
  return d.toISOString().replace(/\D/g,'')
}



// WEBPACK FOOTER //
// ./src/Firebase/apiAccount.js